import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ApiResourceLocation, Dictionary } from '@softline/core';
import {
  SOFTLINE_API_GARAGE_NOTIFICATION,
  SOFTLINE_API_GARAGE_NOTIFICATION_TEMPLATE,
} from '../garage.api';
import { NotificationTemplate } from '../models/notification-template';

@Injectable()
export class NotificationRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  private createLocation(
    path: string,
    pathParams?: Dictionary<unknown>
  ): ApiResourceLocation {
    return pathParams ? { path, pathParams } : { path };
  }

  retrieve(id: number): Promise<NotificationTemplate[]> {
    return this.#dataAccess.get(
      this.createLocation(SOFTLINE_API_GARAGE_NOTIFICATION_TEMPLATE, { id })
    );
  }

  sendNotification(id: number, template: object): Promise<any> {
    return this.#dataAccess.create(
      this.createLocation(SOFTLINE_API_GARAGE_NOTIFICATION, { id }),
      template
    );
  }
}
